import React, { useState, useEffect } from 'react';
import './jobs.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Dropzone from 'react-dropzone';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AiOutlineCheckCircle, AiOutlineWarning } from 'react-icons/ai';

function Jobs() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobilePhone: '',
    ssn: '',
    dob: '',
    address: '',
    state: '',
    country: '',
    city: '',
    postalCode: '',
    acknowledge: false,
    passportFront: null,
    passportBack: null,
  });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, type, checked } = e.target;

    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        [id]: checked,
      }));
    } else {
      const { value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [id]: value,
      }));
    }
  };

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
    }));
  }, []);

  const onDropFront = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setFormData((prevData) => ({
      ...prevData,
      passportFront: file,
    }));
  };

  const onDropBack = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setFormData((prevData) => ({
      ...prevData,
      passportBack: file,
    }));
  };

  const handleSendDataToServer = async () => {
    // Validation checks
    const isValid = validateForm();

    if (!isValid) {
      console.log('Form validation failed');
      return;
    }

    setLoading(true);

    try {
      // Prepare the data to send to the server
      const requestData = {
        formData: {
          ...formData,
        },
        passportFront: formData.passportFront ? formData.passportFront.name : '',
        passportBack: formData.passportBack ? formData.passportBack.name : '',
      };
      console.log('Request Data:', requestData); 
      // Send data to the server using Axios
      const response = await axios.post('http://localhost:5001/submit', requestData);

      console.log('Server Response:', response.data);
      // Check if the server responded successfully
      if (response.status === 200) {
        toast.success('Data submitted successfully!', { icon: <AiOutlineCheckCircle /> });
        navigate('/success');
      } else {
        toast.error('Failed to submit data to the server.', { icon: <AiOutlineWarning /> });
      }
    } catch (error) {
      toast.error('Error submitting data to the server.', { icon: <AiOutlineWarning /> });
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    // Perform validation checks here
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.mobilePhone ||
      !formData.address ||
      !formData.state ||
      !formData.country ||
      !formData.city ||
      !formData.postalCode ||
      !formData.ssn ||
      !formData.dob
    ) {
      toast.error('All fields are required', { icon: <AiOutlineWarning /> });
      return false;
    }

    // Validate email using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Invalid email format', { icon: <AiOutlineWarning /> });
      return false;
    }

    // Validate DOB not less than 13 years
    const dob = new Date(formData.dob);
    const thirteenYearsAgo = new Date();
    thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
    if (dob > thirteenYearsAgo) {
      toast.error('DOB should be at least 13 years ago', { icon: <AiOutlineWarning /> });
      return false;
    }

    // All validation checks passed
    return true;
  };

  return (
    <div className="container mt-5">
      {/* Your existing form structure */}
      <form className="row g-3 submission-form">
        {/* First Column */}
        <div className="col-md-6">
          <div className="mb-3">
            <label htmlFor="firstName" className="form-label">
              First Name:
            </label>
            <input
              type="text"
              className="form-control"
              id="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="lastName" className="form-label">
              Last Name:
            </label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email:
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="mobilePhone" className="form-label">
              Mobile Phone:
            </label>
            <input
              type="tel"
              className="form-control"
              id="mobilePhone"
              value={formData.mobilePhone}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="address" className="form-label">
              Address:
            </label>
            <textarea
              className="form-control"
              id="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Second Column */}

        <div className="col-md-6">

        <div className="mb-3">
            <label htmlFor="country" className="form-label">
              Country:
            </label>
            <input
              type="text"
              className="form-control"
              id="country"
              value={formData.country}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="state" className="form-label">
              State / Province / Region:
            </label>
            <input
              type="text"
              className="form-control"
              id="state"
              value={formData.state}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="city" className="form-label">
              City:
            </label>
            <input
              type="text"
              className="form-control"
              id="city"
              value={formData.city}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="postalCode" className="form-label">
              Postal Code:
            </label>
            <input
              type="text"
              className="form-control"
              id="postalCode"
              value={formData.postalCode}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="ssn" className="form-label">
              Social Security Number:
            </label>
            <input
              type="text"
              className="form-control"
              id="ssn"
              value={formData.ssn}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="dob" className="form-label">
              Date of Birth:
            </label>
            <input
              type="date"
              className="form-control"
              id="dob"
              value={formData.dob}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Dropzone for Passport Front */}
        <div className="col-md-8">
          <Dropzone onDrop={onDropFront}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                {formData.passportFront ? (
                  <div className="preview-container">
                    <p>Preview Passport Front:</p>
                    <img
                      src={URL.createObjectURL(formData.passportFront)}
                      alt="Passport Front Preview"
                      className="preview-image"
                    />
                  </div>
                ) : (
                  <p className="text-center mb-0">Drag 'n' drop Passport Front file here, or click to select a file</p>
                )}
              </div>
            )}
          </Dropzone>
        </div>

        {/* Dropzone for Passport Back */}
        <div className="col-md-8">
          <Dropzone onDrop={onDropBack}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="dropzone">
                <input {...getInputProps()} />
                {formData.passportBack ? (
                  <div className="preview-container">
                    <p>Preview Passport Back:</p>
                    <img
                      src={URL.createObjectURL(formData.passportBack)}
                      alt="Passport Back Preview"
                      className="preview-image"
                    />
                  </div>
                ) : (
                  <p className="text-center mb-0">Drag 'n' drop Passport Back file here, or click to select a file</p>
                )}
              </div>
            )}
          </Dropzone>
        </div>

        <div className="mb-3">
          <label className="form-check-label">
            <input
              type="checkbox"
              id="acknowledge"
              className="form-check-input"
              checked={formData.acknowledge}
              onChange={handleChange}
            />
            I acknowledge and agree to the terms and conditions
          </label>
        </div>

        <div className="mb-3">
          <button
            type="button"
            className="btn btn-primary me-2"
            onClick={handleSendDataToServer}
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : null}
            {loading ? 'Submitting...' : 'SUBMIT'}
          </button>
          <button type="button" className="btn btn-secondary">
            CANCEL
          </button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
}

export default Jobs;
